import styled from "styled-components";
import { Description } from "../../adviceStyled";

export const ContentWrapper = styled.div`
  .AdviceHeaderText {
    margin-bottom: 16px;
  }
`;

export const MarginLeftWrapper = styled.div`
  margin-left: 40px;
`;

export const PriceWrapper = styled.div`
  align-self: flex-start;
  margin-top: 12px;
`;

export const MarkdownWrapper = styled.div`
  & ol {
    margin-top: ${({ theme }) => theme.spacing.sm};
  }

  & ul {
    margin-top: ${({ theme }) => theme.spacing.sm};
  }

  & li {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
    margin-left: ${({ theme }) => theme.spacing.md};
  }
`;

export const CardSubHeader = styled(Description)`
  align-items: center;
  display: flex;

  & + * {
    margin-top: 0;
  }

  & + p {
    margin-top: ${({ theme }) => theme.spacing.md};
  }
`;

export const StyledCheckbox = styled.div`
  & > div {
    display: flex;
  }
`;
